import { Box, Divider, Grid, Typography } from '@mui/material'
import { Button } from 'global/components/Button'
import { hasPermission } from 'hooks/useBackendMenu'

export function Seguranca() {
    return hasPermission(['update', 'Funcionários'], () => (
        <Box component="section" id="seguranca">
            <Divider sx={{ marginBottom: 2, marginTop: 3 }} textAlign="center">
                Segurança
            </Divider>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="body2" sx={{ textAlign: 'center' }}>
                        A senha padrão atribuída ao funcionário é o seu CPF.
                        Caso necessário, é possível modificá-la. <br />O
                        funcionário também possui a opção de alterar a própria
                        senha por meio do seu perfil.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    <Button href="alterar-senha" color="warning">
                        Alterar senha do funcionário
                    </Button>
                </Grid>
            </Grid>
        </Box>
    ))
}
